import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import { useFocusTrap } from '../hooks/useFocusTrap.js';

export default function ModalShell({ isOpen, onClose, children, className }) {
  const { containerRef, onKeyDown } = useFocusTrap(isOpen);

  useEffect(() => {
    if (!isOpen) return;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className={className}
        role="dialog"
        aria-modal="true"
        ref={containerRef}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
